<template>
  <Navbar />
  <ScrollButton />

  <section
    class="banner-title"
    style="background-image: url(images/bv-img.jpeg); background-position: center; background-size: cover"
  >
    <div class="auto-container">
      <div class="row clearfix">
        <div class="title-column col-md-6 col-sm-6 col-xs-12">
          <h1>Kalite Politikamız</h1>
        </div>
        <div class="col-md-6 col-sm-6 col-xs-12">
          <ul class="bread-crumb clearfix">
            <li><a href="#">Anasayfa</a></li>
            <li class="active">Kalite Politikamız</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section class="page-container">
    <div class="auto-container">
      <div class="row">
        <div class="content-side col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="blog-section">
            <div class="news-block-detail">
              <div class="text-content">
                <blockquote>
                <p>
                  İntek Teknoloji olarak müşteri memnuniyetini esas alarak, elektronik ve otomasyon sektöründe yüksek kalite standartlarıyla hizmet sunmayı taahhüt ediyoruz. Kalite politikamız şu temel ilkeler üzerine kuruludur:
                </p>
                <ul class="quality-list">
                  <li>
                    <strong>Müşteri Memnuniyeti:</strong> Müşterilerimizin ihtiyaçlarını anlamak ve beklentilerini aşmak için sürekli çaba gösteriyoruz. Geri bildirimleri dikkate alarak sistemimizi sürekli geliştiriyoruz.
                  </li>
                  <li>
                    <strong>Yüksek Kalite Standartları:</strong> Ürün ve hizmetlerimizin kalitesini daima en üst düzeyde tutuyor, personelimizi sürekli eğitimlerle kalite bilinci konusunda geliştiriyoruz.
                  </li>
                  <li>
                    <strong>İnovasyon ve Teknoloji:</strong> Güncel teknolojileri yakından takip ediyor, Ar-Ge yatırımlarıyla yenilikçi çözümler üretiyoruz. Gelişen dünyaya uyum sağlıyoruz.
                  </li>
                  <li>
                    <strong>Çevreye Duyarlılık:</strong> Üretim süreçlerimizde çevresel etkileri azaltmaya özen gösteriyor, sürdürülebilirlik ilkeleri doğrultusunda doğal kaynakları koruyoruz.
                  </li>
                  <li>
                    <strong>Sürekli İyileştirme:</strong> İş süreçlerimizi düzenli olarak gözden geçiriyor ve veriye dayalı kararlarla iyileştirme çalışmalarına yön veriyoruz.
                  </li>
                  <li>
                    <strong>Adil ve Eşitlikçi Yaklaşım:</strong> Tüm çalışanlarımıza eşit fırsatlar sunuyor, çeşitliliğe ve farklı bakış açılarına değer veriyoruz.
                  </li>
                </ul>
                <p class="mt-3">
                  Bu ilkeler doğrultusunda kalite yönetim sistemimizi sürdürüyor; güvenilir, yenilikçi ve sürdürülebilir çözümlerle sektördeki konumumuzu güçlendiriyoruz.
                </p>
                </blockquote>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <Footer />
</template>

<script>
import Navbar from "@/components/Navbar-2.vue";
import ScrollButton from "@/components/ScrollButton.vue";
import Footer from "@/components/Footer.vue";

export default {
  components: {
    Navbar,
    ScrollButton,
    Footer,
  },
};
</script>

<style scoped>
.banner-title {
  padding: 60px 0;
  color: #fff;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);
}

.title-column h1 {
  font-size: 2.5rem;
  font-weight: bold;
}

.bread-crumb {
  display: flex;
  justify-content: flex-end;
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: 0.95rem;
}

.bread-crumb li {
  margin-left: 10px;
}

.page-container {
  padding: 40px 0;
}

.title-content h3 {
  font-size: 1.75rem;
  margin-bottom: 1rem;
  font-weight: 600;
}

.text-content {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 30px;
  justify-content: center;
  align-items: flex-start;
  margin-top: 0.5rem;
}
.quality-list {
  padding-left: 20px;
  margin-top: 1rem;
}

.quality-list li {
  margin-bottom: 1rem;
  list-style: none;
}

.quality-list li::before {
  content: "\2022";
  color: #007bff;
  font-weight: bold;
  display: inline-block;
  width: 1em;
  margin-left: -1em;
}

@media (max-width: 768px) {
  .title-column h1 {
    font-size: 1.8rem;
    text-align: center;
  }

  .bread-crumb {
    justify-content: center;
    font-size: 0.85rem;
  }

  .text-content {
    padding: 20px;
  }

  .quality-list li {
    margin-left: 1em;
  }
}
</style>
